// ======================================================================
// File Name       : course
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { STRUCTURE_LEVEL } from '../../constants';

export function postCourseEditDisplayOrder(data) {
  return commonCallApi({
    path: 'course/EditDisplayOrder',
    data,
  });
}

export function postCourseGetList(data) {
  return commonCallApi({
    path: 'course/GetList',
    data,
  });
}

export function postCourseEdit(editType, data) {
  return commonCallApi({
    path: 'course/Edit',
    data: {
      editType,
      courseInfo: data,
    },
  });
}

export function postUserCourseRelationEdit(editType, data) {
  return commonCallApi({
    path: 'courseUserRelation/Edit',
    data: {
      editType,
      courseInfo: data,
    },
  });
}

export function postUserCourseRelationGetList(data) {
  return commonCallApi({
    path: 'userCourseRelation/GetList',
    data,
  });
}

export function postContainerGetStructure(data) {
  // Default コンテナ構造取得API's parameter
  const GET_STRUCTURE_DEFAULT = {
    targetCourseSecernId: null,
    targetBoxSecernId: null,
    recursiveType: STRUCTURE_LEVEL.DIRECT,
  };

  return commonCallApi({
    path: 'container/GetStructure',
    data: { ...GET_STRUCTURE_DEFAULT, ...data },
  });
}

export function postContainerGetStructureByCourseSecernId(courseSecernId) {
  return postContainerGetStructure({
    targetCourseSecernId: courseSecernId,
    recursiveType: STRUCTURE_LEVEL.ALL,
  });
}

export function postResetCourseCondition(data) {
  return commonCallApi({
    path: 'learningOperation/ResetCourseCondition',
    data,
  });
}

export function postGroupCourseRelationGetList(data) {
  return commonCallApi({
    path: 'groupCourseRelation/GetList',
    data,
  });
}

export function postGroupCourseRelationEdit(editType, data) {
  return commonCallApi({
    path: 'courseGroupRelation/Edit',
    data: {
      editType,
      courseInfo: data,
    },
  });
}
